// extracted by mini-css-extract-plugin
export default {"container":"Location_container_Yt5hD","description":"Location_description_ZCp8y"};